(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combined-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    function parseStickyConfig() {
      try {
        const configElement = document.querySelector('[data-combined-sticky-atc-config]');
        return configElement ? JSON.parse(configElement.textContent || '{}') : {};
      } catch (error) {
        return {};
      }
    }

    class CombinedStickyATC {
      constructor(root) {
        this.root = root;
        this.config = parseStickyConfig();
        this.sectionEl = document.querySelector('.sibling-product-section');
        this.selectionEl = this.root.querySelector('[data-combined-sticky-selection]');
        this.priceEl = this.root.querySelector('[data-combined-sticky-price]');
        this.stickyButton = this.root.querySelector('[data-sticky-atc-btn]');
        this.anchorObserver = null;
        this.accordionObserver = null;
        this.observedAnchor = null;
        this.boundSync = this.syncState.bind(this);
        this.handleSectionRefreshed = () => {
          this.config = parseStickyConfig();
          this.sectionEl = document.querySelector('.sibling-product-section');
          this.syncState();
          this.observeAnchor();
          this.observeAccordionSelection();
        };
      }

      isMobileViewport() {
        return window.matchMedia('(max-width: 991px)').matches;
      }

      isEnabledForCurrentViewport() {
        return this.isMobileViewport()
          ? this.config.enableMobile
          : this.config.enableDesktop;
      }

      shouldShowStickyForAnchor(anchor) {
        if (!anchor || typeof anchor.getBoundingClientRect !== 'function') {
          return false;
        }
        const rect = anchor.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const isIntersecting = rect.top < viewportHeight && rect.bottom > 0;
        return !isIntersecting && rect.top < 0;
      }

      shouldShowStickyFromEntry(entry) {
        if (!entry) {
          return false;
        }
        const rect = entry.boundingClientRect;
        return !entry.isIntersecting && rect.top < 0;
      }

      getMainAtcButton() {
        if (!this.sectionEl) {
          return null;
        }
        return this.sectionEl.querySelector('[data-combined-atc-anchor]');
      }

      getQuantity() {
        if (!this.sectionEl) {
          return 1;
        }
        const quantityInput = this.sectionEl.querySelector('.quantity-selector-input');
        const quantityValue = parseInt(quantityInput && quantityInput.value, 10);
        if (!isNaN(quantityValue) && quantityValue > 0) {
          return quantityValue;
        }
        return 1;
      }

      getBundleTypeName() {
        if (!this.sectionEl) {
          return '';
        }
        const bundleNameElement = this.sectionEl.querySelector('.bundle-accordion.selected [data-bundle-name]');
        if (bundleNameElement && bundleNameElement.textContent) {
          return bundleNameElement.textContent.trim();
        }
        return '';
      }

      getSelectedProductBiId() {
        if (!this.sectionEl) {
          return '';
        }
        const selectedAccordion = this.sectionEl.querySelector('.bundle-accordion.selected');
        if (!selectedAccordion) {
          return '';
        }
        if (selectedAccordion.classList.contains('bundle-accordion-subscription')) {
          return 'Subscription';
        }
        if (selectedAccordion.classList.contains('bundle-accordion-exchange')) {
          return 'Exchange';
        }
        return '';
      }

      getVariantLabel() {
        if (!this.sectionEl) {
          return '';
        }
        const selectedLabel = this.sectionEl.querySelector('.variant-option.selected .variant-option__label');
        if (selectedLabel && selectedLabel.textContent) {
          return selectedLabel.textContent.trim();
        }
        const variantButton = this.sectionEl.querySelector('.variant-option.selected');
        if (variantButton && variantButton.dataset && variantButton.dataset.optionValue) {
          return String(variantButton.dataset.optionValue).trim();
        }
        return '';
      }

      getSelectedPriceText() {
        if (!this.sectionEl) {
          return '';
        }
        const selectedAccordion = this.sectionEl.querySelector('.bundle-accordion.selected');
        if (!selectedAccordion) {
          return '';
        }
        const priceElement = selectedAccordion.querySelector('[data-bundle-accordion-price]');
        if (priceElement && priceElement.textContent) {
          return priceElement.textContent.trim();
        }
        return '';
      }

      syncState() {
        if (!this.root || !this.sectionEl) {
          return;
        }

        const quantity = this.getQuantity();
        const bundleTypeName = this.getBundleTypeName();
        const variantLabel = this.getVariantLabel();
        const detailParts = [String(quantity)];
        if (variantLabel) {
          detailParts.push(variantLabel);
        }
        const selectionParts = [];
        if (bundleTypeName) {
          selectionParts.push(bundleTypeName);
        }
        const detailText = detailParts.join(' ');
        if (detailText) {
          selectionParts.push(detailText);
        }
        if (this.selectionEl) {
          this.selectionEl.textContent = selectionParts.join(' · ');
        }
        if (this.priceEl) {
          this.priceEl.textContent = this.getSelectedPriceText();
        }

        const mainButton = this.getMainAtcButton();
        if (!this.stickyButton) {
          return;
        }
        if (!mainButton) {
          this.handleMissingAnchor();
          return;
        }

        const isAvailable = mainButton.dataset.variantAvailable !== 'false' && !mainButton.disabled;

        this.stickyButton.disabled = !isAvailable;
        this.stickyButton.textContent = isAvailable
          ? this.config.buttonText
          : this.config.soldOutText;
        this.stickyButton.setAttribute('bi-id', this.getSelectedProductBiId());
      }

      setVisible(isVisible) {
        if (!this.root) {
          return;
        }
        this.root.hidden = !isVisible;
        this.root.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        document.body.classList.toggle('combined-sticky-atc-visible', isVisible);
      }

      handleMissingAnchor() {
        this.setVisible(false);
        if (this.stickyButton) {
          this.stickyButton.disabled = true;
        }
      }

      updateVisibility(observerEntry) {
        const anchor = this.getMainAtcButton();
        if (!anchor) {
          this.handleMissingAnchor();
          return;
        }
        const shouldShow = observerEntry
          ? this.shouldShowStickyFromEntry(observerEntry)
          : this.shouldShowStickyForAnchor(anchor);
        this.setVisible(shouldShow && this.isEnabledForCurrentViewport());
      }

      observeAnchor() {
        if (this.anchorObserver) {
          if (this.observedAnchor) {
            this.anchorObserver.unobserve(this.observedAnchor);
          }
          this.anchorObserver.disconnect();
        }

        const anchor = this.getMainAtcButton();
        this.observedAnchor = anchor;
        if (!anchor) {
          this.handleMissingAnchor();
          return;
        }

        this.anchorObserver = new IntersectionObserver(
          ([observerEntry]) => {
            this.updateVisibility(observerEntry);
          },
          { threshold: 0.01, rootMargin: '0px' }
        );

        this.anchorObserver.observe(anchor);
        this.updateVisibility();
      }

      observeAccordionSelection() {
        if (this.accordionObserver) {
          this.accordionObserver.disconnect();
        }
        if (!this.sectionEl) {
          return;
        }

        const bundleSelector = this.sectionEl.querySelector('[data-bundle-selector-block]');
        if (!bundleSelector) {
          return;
        }

        this.accordionObserver = new MutationObserver(() => {
          this.syncState();
        });

        this.accordionObserver.observe(bundleSelector, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true,
          childList: false,
        });
      }

      scrollToMainAtc(mainButton) {
        if (!mainButton) {
          return;
        }
        mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      getAtcBlock(mainButton) {
        if (!mainButton) {
          return null;
        }
        return mainButton.closest('[data-add-to-cart-block]');
      }

      getAtcConfig(atcBlock) {
        if (!atcBlock || !atcBlock.dataset.addToCartBlock) {
          return null;
        }
        try {
          const configElement = document.querySelector(
            '[data-add-to-cart-data="' + atcBlock.dataset.addToCartBlock + '"]'
          );
          if (!configElement) {
            return null;
          }
          return JSON.parse(configElement.textContent);
        } catch (error) {
          return null;
        }
      }

      hasUncheckedRequiredTerms(atcBlock, atcConfig) {
        if (!atcConfig || !atcConfig.termsRequired || !atcConfig.showTerms || !atcBlock) {
          return false;
        }
        const termsCheckbox = atcBlock.querySelector('input[name="terms"], [data-terms-checkbox]');
        if (!termsCheckbox) {
          return false;
        }
        return !termsCheckbox.checked;
      }

      showTermsValidationError(atcBlock, atcConfig) {
        if (!atcBlock) {
          return;
        }
        atcBlock.classList.add('pdp-atc-error');
        const termsErrorElement = atcBlock.querySelector('[data-terms-error]');
        if (!termsErrorElement) {
          return;
        }
        termsErrorElement.textContent = (atcConfig && atcConfig.termsErrorMessage) || '';
        termsErrorElement.classList.remove('d-none');
      }

      handleStickyClick() {
        const mainButton = this.getMainAtcButton();
        if (!mainButton) {
          return;
        }

        if (mainButton.disabled || mainButton.dataset.variantAvailable === 'false') {
          this.scrollToMainAtc(mainButton);
          return;
        }

        const atcBlock = this.getAtcBlock(mainButton);
        const atcConfig = this.getAtcConfig(atcBlock);

        if (this.hasUncheckedRequiredTerms(atcBlock, atcConfig)) {
          this.showTermsValidationError(atcBlock, atcConfig);
          this.scrollToMainAtc(mainButton);
          return;
        }

        mainButton.click();

        requestAnimationFrame(() => {
          if (atcBlock && atcBlock.classList.contains('pdp-atc-error')) {
            this.scrollToMainAtc(mainButton);
          }
        });
      }

      bindEvents() {
        document.addEventListener('variant:changed', this.boundSync);
        document.addEventListener('quantity:changed', this.boundSync);
        document.addEventListener('lineItemsToSubscribe:updated', this.boundSync);
        document.addEventListener('sellingPlanId:updated', this.boundSync);
        document.addEventListener('section:refreshed', this.handleSectionRefreshed);

        this.handleResize = () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => {
            this.observeAnchor();
            this.syncState();
          }, 150);
        };
        window.addEventListener('resize', this.handleResize);

        if (!this.stickyButton) {
          return;
        }

        this.stickyButton.addEventListener('click', () => {
          this.handleStickyClick();
        });
      }

      init() {
        if (!this.root || !this.sectionEl) {
          return;
        }

        this.syncState();
        this.observeAnchor();
        this.observeAccordionSelection();
        this.bindEvents();
        this.updateVisibility();
      }

      destroy() {
        if (this.anchorObserver) {
          this.anchorObserver.disconnect();
        }
        if (this.accordionObserver) {
          this.accordionObserver.disconnect();
        }
        if (this.handleResize) {
          window.removeEventListener('resize', this.handleResize);
        }
        clearTimeout(this.resizeTimeout);
        document.removeEventListener('variant:changed', this.boundSync);
        document.removeEventListener('quantity:changed', this.boundSync);
        document.removeEventListener('lineItemsToSubscribe:updated', this.boundSync);
        document.removeEventListener('sellingPlanId:updated', this.boundSync);
        document.removeEventListener('section:refreshed', this.handleSectionRefreshed);
        document.body.classList.remove('combined-sticky-atc-visible');
        if (initCombinedStickyATC.activeInstance === this) {
          initCombinedStickyATC.activeInstance = null;
        }
      }
    }

    function initCombinedStickyATC() {
      if (initCombinedStickyATC.activeInstance) {
        initCombinedStickyATC.activeInstance.destroy();
        initCombinedStickyATC.activeInstance = null;
      }

      const root = document.querySelector('[data-combined-sticky-atc]');
      if (!root || !document.querySelector('.sibling-product-section')) {
        return;
      }

      const instance = new CombinedStickyATC(root);
      instance.init();
      root.combinedStickyATCInstance = instance;
      initCombinedStickyATC.activeInstance = instance;
    }

    window.initCombinedStickyATC = initCombinedStickyATC;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCombinedStickyATC);
    } else {
      initCombinedStickyATC();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-controller"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCounterSelector(quantityElement) {
        if (quantityElement.dataset.quantitySelectorInitialized === 'true') { return; }
        quantityElement.dataset.quantitySelectorInitialized = 'true';

        const quantityInput = quantityElement.querySelector('.quantity-selector-input');
        const minusButton = quantityElement.querySelector('.quantity-selector-minus');
        const plusButton = quantityElement.querySelector('.quantity-selector-plus');
        if (!quantityInput || !minusButton || !plusButton) return;

        const popupCardElement = quantityElement.closest('[data-cta-popup-item-card]');
        const isPopupCard = !!popupCardElement;

        const minimumQuantity = 1;
        function currentQuantity() {
            const parsed = parseInt(quantityInput.value);
            return Number.isFinite(parsed) ? parsed : minimumQuantity;
        }


        function popupCardCheckboxUnchecked() {
            if (!isPopupCard) return false;
            const checkboxElement = popupCardElement && popupCardElement.querySelector('[data-cta-popup-item-checkbox]');
            return !!(checkboxElement && !checkboxElement.checked);
        }

        function setValue(quantityValue, options) {
            options = options || {};
            const previousQuantity = quantityInput.value;
            quantityInput.value = quantityValue;
            if (previousQuantity === String(quantityValue)) return;

            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

            const variantId = popupCardElement ? popupCardElement.getAttribute('data-variant-id') : null;
            document.dispatchEvent(new CustomEvent('quantity:changed', {
                detail: { value: quantityValue, input: quantityInput, variantId: variantId },
                bubbles: true
            }));
        }

        minusButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const quantityValue = currentQuantity();
            // Popup cards: at quantity 1, minus acts as unselect (works with min 0 on CTA cards).
            if (isPopupCard && quantityValue <= 1) {
                const checkboxElement = popupCardElement ? popupCardElement.querySelector('[data-cta-popup-item-checkbox]') : null;
                if (checkboxElement) {
                    checkboxElement.checked = false;
                    setValue(0, { allowBelowMin: true });
                    checkboxElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
                return;
            }

            setValue(quantityValue - 1);
        });

        plusButton.addEventListener('click', function (event) {
            if (plusButton.disabled) return;
            event.preventDefault();
            event.stopPropagation();
            setValue(currentQuantity() + 1);
        });

        quantityInput.addEventListener('change', function () {
            const quantityValue = currentQuantity();
            if (quantityValue === 0 && popupCardCheckboxUnchecked()) {
              return setValue(0, { allowBelowMin: true });
            }
            return setValue(quantityValue);
        });
        setValue(currentQuantity());
    }

    const quantitySelectorBlockSelector = '.quantity-controller';

    function initializeQuantitySelectorsInContainer(containerElement) {
        if (!containerElement) return;
        containerElement.querySelectorAll(quantitySelectorBlockSelector).forEach(initCounterSelector);
    }

    if (document.readyState !== 'loading') {
      initializeQuantitySelectorsInContainer(document);
    }
    else document.addEventListener('DOMContentLoaded', () => initializeQuantitySelectorsInContainer(document));

    window.initCounterSelectorsInContainer = initializeQuantitySelectorsInContainer;
})();
  } catch(e) { console.error(e); }
})();

})();
